import { Controller } from "@hotwired/stimulus"
import { resourceCardTemplate } from "@/templates/resource_card"

export default class extends Controller {
  static values = {
    template: String,
    data: Object
  }

  declare readonly templateValue: string
  declare readonly dataValue: any

  async connect() {
    const templates = {
      'resource-card-template': resourceCardTemplate
    }

    const template = templates[this.templateValue]
    if (!template) return

    this.element.innerHTML = template(this.dataValue)
  }
}